import {
  initLoginState,
  actionLoginMap
} from './login'

const initState = {
  local: {},
	
  isLogin: false,
	
  ...initLoginState
}

const actionMap = {
  'user/RESET': (state, payload) => initState,
  ...actionLoginMap
}

export const reducer = (state = initState, action) => {
  const {
    type,
    payload
  } = action
	
  if (type in actionMap) {
    return actionMap[type](state, payload)
  }
	
  return state
}
